import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import MovieCard from "@/components/feature/MovieCard";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import { allSpecials, getMovieById } from "@/lib/content";

export default function SpecialPage() {
  useDocumentMeta({
    title: "主题专题 - 影视内容精选合集 - 国语对白做受69",
    description:
      "国语对白做受69主题专题页，收录年度必看电影、高口碑悬疑剧、古装武侠东方美学等编辑精选影视合集，帮你更快发现值得一看的作品。",
    keywords: "影视专题,影视合集,电影推荐,剧集推荐,国语对白做受69",
  });

  return (
    <Layout>
      <section className="w-full bg-primary-950 text-background-50">
        <div className="w-full max-w-[1400px] mx-auto px-4 md:px-8 py-8 md:py-10">
          <nav className="text-xs md:text-sm text-background-400 mb-4 flex items-center gap-1.5">
            <Link to="/" className="hover:text-accent-400 transition-colors cursor-pointer">
              首页
            </Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-accent-400">主题专题</span>
          </nav>
          <h1 className="text-2xl md:text-4xl font-bold font-heading">主题专题</h1>
          <p className="mt-2 text-sm md:text-base text-background-300 max-w-2xl">
            编辑精心的内容策划，用主题串起值得一看的影视作品。
          </p>
        </div>
      </section>

      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-8 py-10 md:py-14 space-y-14 md:space-y-20">
        {allSpecials.map((special) => (
          <section key={special.id}>
            <div className="relative rounded-lg overflow-hidden">
              <img
                src={special.cover}
                alt={special.title}
                title={`${special.title} - 影视主题专题`}
                className="w-full h-56 md:h-72 object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/60 to-transparent"></div>
              <div className="absolute inset-0 px-6 md:px-10 flex flex-col justify-center max-w-2xl">
                <span className="inline-flex w-fit items-center gap-1.5 px-2.5 py-1 rounded-md bg-accent-500 text-primary-950 text-xs font-bold mb-3">
                  <i className="ri-bookmark-3-line"></i>
                  专题策划
                </span>
                <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading">{special.title}</h2>
                <p className="mt-1.5 text-sm text-accent-400">{special.subtitle}</p>
              </div>
            </div>

            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-3xl">
              {special.description}
            </p>

            <div className="mt-8 space-y-8">
              {special.groups.map((group) => {
                const groupMovies = group.movieIds
                  .map((movieId) => getMovieById(movieId))
                  .filter((m): m is NonNullable<typeof m> => Boolean(m));
                return (
                  <div key={group.title}>
                    <div className="flex items-center gap-3 mb-4">
                      <span className="w-1 h-6 rounded-full bg-accent-500"></span>
                      <div>
                        <h3 className="text-base md:text-lg font-semibold text-foreground-950">{group.title}</h3>
                        <p className="text-xs md:text-sm text-foreground-500">{group.description}</p>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
                      {groupMovies.map((movie) => (
                        <MovieCard key={movie.id} movie={movie} />
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>
          </section>
        ))}
      </div>
    </Layout>
  );
}